var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirefox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5751 4.46606C37.407 5.82626 36.8629 8.88748 38.0474 11.9907C39.2319 15.094 41.0474 14.42 42.1791 17.5845C43.6729 21.7602 42.9776 27.3694 42.9776 27.3694C42.9776 27.3694 44.7734 32.5698 46.0248 27.0458C48.7947 16.6701 38.5751 7.02114 38.5751 4.46606Z",
    fill: "url(#paint0_radial)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3208 47.5434C36.2835 47.5434 45.9745 37.8001 45.9745 25.786C45.9745 13.7719 36.2835 4.02856 24.3324 4.02856C12.3813 4.02856 2.69047 13.7719 2.69047 25.786C2.6673 37.8117 12.3696 47.5434 24.3208 47.5434Z",
    fill: "url(#paint1_radial)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5451 39.2017C40.077 39.532 39.5859 39.8284 39.0756 40.0887C39.7516 39.0983 40.3752 38.0731 40.9439 37.0174C41.4054 36.5067 41.8281 36.0102 42.1726 35.4734C42.3403 35.2096 42.5294 34.8842 42.7295 34.5066C43.9452 32.3164 45.2856 28.7718 45.3236 25.131V25.1222C45.3245 25.0326 45.325 24.943 45.3243 24.8532C45.3306 23.9393 45.2371 23.0274 45.0456 22.1338C45.0554 22.2036 45.064 22.2733 45.0728 22.3431C45.062 22.2894 45.0529 22.2352 45.0413 22.1814C45.0592 22.2807 45.0735 22.3766 45.089 22.4733C45.3374 24.5814 45.1605 26.6378 44.2752 28.1538C44.2613 28.1759 44.2469 28.1967 44.2328 28.2183C44.6918 25.9142 44.8454 23.3702 44.3347 20.8232C44.3347 20.8232 44.1304 19.585 42.609 15.8261C41.7333 13.6625 40.1781 11.8887 38.8041 10.5965C37.5997 9.10642 36.5059 8.10647 35.9029 7.47159C34.6434 6.1453 34.1155 5.15115 33.8987 4.50247C33.7107 4.40823 31.3067 2.07286 31.1157 1.98389C30.0664 3.61081 26.7664 8.69974 28.3362 13.4544C29.0476 15.6092 30.8468 17.8455 32.7297 19.1001C32.8124 19.1945 33.8501 20.3216 34.3436 22.8638C34.8532 25.4903 34.5853 27.5397 33.5365 30.5703C32.3031 33.2291 29.143 35.8575 26.1841 36.1264C19.8585 36.7011 17.5427 32.9504 17.5427 32.9504C19.803 33.8541 22.3021 33.665 23.8219 32.7282C25.3536 31.7806 26.2802 31.0781 27.0322 31.3551C27.7736 31.6309 28.3639 30.8304 27.8342 30.0006C27.4252 29.3706 26.8399 28.8748 26.1512 28.575C25.4626 28.2751 24.7009 28.1844 23.9611 28.3141C22.4277 28.5633 21.0232 29.778 19.0141 28.6016C18.8841 28.5262 18.7582 28.4438 18.6371 28.3547C18.5047 28.2676 19.0677 28.4872 18.9363 28.3883C18.5453 28.1759 17.8534 27.7131 17.6738 27.5484C17.6439 27.521 17.9772 27.6547 17.9473 27.6272C16.0688 26.0803 16.3034 25.0353 16.3624 24.3799C16.4097 23.8556 16.7509 23.1837 17.3259 22.9111C17.6036 23.0627 17.7766 23.1784 17.7766 23.1784C17.7766 23.1784 17.6582 22.9364 17.5941 22.8089C17.6166 22.7991 17.638 22.8017 17.6604 22.7922C17.8879 22.902 18.391 23.1873 18.6558 23.3613C19.0008 23.6046 19.1108 23.8216 19.1108 23.8216C19.1108 23.8216 19.2016 23.7716 19.1344 23.5594C19.11 23.4724 19.0053 23.1958 18.6636 22.9168L18.685 22.9191C18.8895 23.0357 19.0832 23.1702 19.2638 23.3211C19.3602 22.9709 19.5335 22.6051 19.4954 21.9508C19.4721 21.4908 19.4828 21.3716 19.4017 21.194C19.3292 21.0414 19.4424 20.9819 19.5685 21.1403C19.5469 21.0162 19.5108 20.895 19.4608 20.7793L19.4618 20.7674C19.6192 20.2193 22.791 18.7937 23.0219 18.6271C23.4012 18.3587 23.7193 18.0129 23.9552 17.6125C24.1316 17.3313 24.2643 16.937 24.2966 16.3387C24.3139 15.9073 24.1133 15.62 20.906 15.2842C20.0289 15.1978 19.5143 14.5622 19.2218 13.9757C19.1685 13.8494 19.1141 13.7349 19.0596 13.6205C19.0077 13.4868 18.966 13.3493 18.9349 13.2093C19.4592 11.7033 20.3402 10.4299 21.6357 9.46779C21.7063 9.40349 21.3536 9.48428 21.4242 9.41998C21.5065 9.34496 22.044 9.12842 22.1455 9.07964C22.2695 9.0211 21.6147 8.74306 21.0366 8.81076C20.4479 8.8771 20.3229 8.94735 20.0087 9.08057C20.1391 8.95076 20.5537 8.78062 20.4565 8.78174C19.8218 8.87906 19.0331 9.24798 18.3589 9.66584C18.3576 9.59307 18.3715 9.52084 18.3997 9.45374C18.0855 9.58701 17.3138 10.1263 17.0892 10.5826C17.0988 10.4952 17.1032 10.4072 17.1021 10.3192C16.8628 10.5188 16.6469 10.745 16.4585 10.9933L16.4467 11.0039C14.6244 10.2698 13.0207 10.2223 11.6637 10.5514C11.3668 10.2533 11.2218 10.4712 10.5462 8.9871C10.5003 8.89774 10.5815 9.07535 10.5462 8.9871C10.4351 8.6993 10.614 9.3711 10.5462 8.9871C9.41043 9.8833 7.916 10.899 7.19863 11.6159C7.18975 11.6445 8.03551 11.3769 7.19863 11.6159C6.90556 11.6996 6.92546 11.8735 6.88092 13.4452C6.87019 13.5643 6.8797 13.6978 6.87004 13.8051C6.29697 14.5352 5.90668 15.1535 5.75907 15.4739C5.01795 16.751 4.2017 18.7418 3.41048 21.891C3.75948 21.0374 4.18024 20.2149 4.66824 19.4324C4.01029 21.104 3.37424 23.7289 3.24707 27.7712C3.40623 26.9371 3.61032 26.1121 3.85844 25.3C3.70311 28.6536 4.28144 32.0008 5.55307 35.1078C6.00814 36.221 6.76087 37.9105 8.04229 39.7615C12.0683 43.9975 17.7469 46.6347 24.0351 46.6347C30.5995 46.6347 36.4943 43.7626 40.5451 39.2017Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6872 42.2784C43.632 41.3584 47.1491 33.1711 42.6326 33.0101C38.5529 32.8797 31.924 42.7125 35.6872 42.2784Z",
    fill: "url(#paint3_radial)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2049 31.3378C48.671 28.1567 47.2458 21.2852 47.2458 21.2852C47.2458 21.2852 45.1363 23.7358 43.7031 27.6422C42.2875 31.5105 39.9185 33.2592 43.2049 31.3378Z",
    fill: "url(#paint4_radial)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8522 46.3444C33.473 48.7761 40.0229 42.7727 35.9855 40.7678C32.3147 38.9597 22.2351 45.1945 25.8522 46.3444Z",
    fill: "url(#paint5_radial)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7731 34.2552C43.9585 33.9936 44.2092 33.156 44.4307 32.7815C45.7761 30.6097 45.7856 28.878 45.7856 28.8383C46.5983 24.7789 46.5246 23.1212 46.0247 20.0557C45.6222 17.5874 43.8626 14.0512 42.3383 12.3484C40.7676 10.594 41.8742 11.1656 40.3534 9.88413C39.0203 8.40642 37.7278 6.9431 37.0239 6.35462C31.9373 2.10208 32.0522 1.19881 32.1502 1.04481C32.1336 1.06291 32.1094 1.08979 32.0784 1.12496C32.0181 0.884812 31.9756 0.682861 31.9756 0.682861C31.9756 0.682861 29.1951 3.46335 28.6097 8.09749C28.2276 11.1229 29.3601 14.2768 31 16.2926C31.8539 17.3373 32.8189 18.286 33.878 19.1219V19.1206C35.1171 20.9 35.799 23.0957 35.799 25.4576C35.799 31.372 31.0019 36.1665 25.0843 36.1665C24.2778 36.1669 23.4738 36.0766 22.6875 35.8972C19.8955 35.3651 18.2832 33.9567 17.4791 33.0006C17.0183 32.4526 16.8223 32.0531 16.8223 32.0531C19.3239 32.9492 22.0899 32.7618 23.772 31.8327C25.4671 30.893 26.4927 30.1963 27.325 30.471C28.1455 30.7445 28.7987 29.9507 28.2128 29.1278C27.6386 28.3061 26.1445 27.1292 23.9261 27.4553C22.2291 27.7025 20.6745 28.907 18.451 27.7404C18.3078 27.666 18.1685 27.5843 18.0337 27.4955C17.8871 27.4091 18.5102 27.627 18.3648 27.5288C17.9321 27.3182 17.1661 26.8591 16.9676 26.6959C16.9344 26.6688 17.3033 26.8013 17.27 26.774C15.1909 25.2399 15.4505 24.2036 15.5159 23.5536C15.5682 23.0336 15.9458 22.3672 16.5822 22.097C16.8895 22.2473 17.081 22.362 17.081 22.362C17.081 22.362 16.9499 22.122 16.879 21.9955C16.9038 21.9861 16.9275 21.9885 16.9522 21.979C17.204 22.0879 17.7608 22.3707 18.0539 22.5434C18.4358 22.7847 18.5575 22.9999 18.5575 22.9999C18.5575 22.9999 18.658 22.9503 18.5836 22.7399C18.5564 22.6536 18.4407 22.3793 18.0625 22.1026L18.0862 22.105C18.3107 22.2194 18.525 22.3528 18.7269 22.5036C18.8335 22.1563 19.0253 21.7935 18.9831 21.1447C18.9574 20.6885 18.9693 20.5703 18.8795 20.3941C18.7992 20.2429 18.9246 20.1838 19.064 20.3411C19.0399 20.217 18.9998 20.0966 18.9448 19.9829L18.946 19.9711C19.1201 19.4275 22.6306 18.0137 22.8861 17.8485C23.2979 17.59 23.65 17.247 23.9191 16.8421C24.1142 16.5633 24.2612 16.1722 24.297 15.579C24.309 15.3116 24.2267 15.1001 23.297 14.8977C22.739 14.7763 21.8758 14.6581 20.5442 14.5332C19.5735 14.4475 19.0038 13.8172 18.6802 13.2356C18.6211 13.1103 18.5609 12.9966 18.5007 12.8833C18.4434 12.7514 18.3972 12.615 18.3626 12.4755C18.9435 10.9548 19.9896 9.65631 21.3518 8.7651C21.4298 8.7013 21.0396 8.78144 21.1177 8.71769C21.2088 8.6433 21.8037 8.42857 21.916 8.38018C22.0533 8.32232 21.3285 8.04652 20.6888 8.11354C20.0372 8.17935 19.8988 8.24896 19.5511 8.38115C19.6954 8.25242 20.1543 8.08359 20.0467 8.08481C19.3443 8.1813 18.4711 8.5472 17.7248 8.96154C17.7234 8.88889 17.7388 8.81691 17.7698 8.7512C17.4221 8.88335 16.568 9.41822 16.3194 9.87071C16.3301 9.78408 16.3349 9.69682 16.3338 9.60954C16.0719 9.80471 15.833 10.0289 15.6216 10.2778L15.6085 10.2885C13.5916 9.56042 11.8167 9.5133 10.3148 9.83969C9.98619 9.54403 9.4579 9.09696 8.71029 7.62505C8.65951 7.53642 8.63224 7.80823 8.59322 7.72071C8.30273 7.04691 8.12722 5.94296 8.15605 5.18188C8.15605 5.18188 7.55517 5.45574 7.05785 6.59944C6.96551 6.80505 6.90629 6.91847 6.84712 7.03188C6.8199 7.06496 6.90883 6.65627 6.89463 6.67852C6.80819 6.82486 6.58458 7.02935 6.48629 7.29403C6.41878 7.49018 6.3241 7.60003 6.26366 7.84466L6.24946 7.8671C6.24458 7.79501 6.26736 7.57047 6.25078 7.61652C6.01768 8.08747 5.81708 8.57383 5.65039 9.07218C5.38263 9.95247 5.07093 11.1507 5.02151 12.7095C5.00961 12.8277 5.02019 12.96 5.00946 13.0664C4.37532 13.7905 3.94322 14.4036 3.77985 14.7214C2.96 15.9883 2.05659 17.9627 1.18083 21.0857C1.57046 20.2326 2.03639 19.4165 2.57293 18.6472C1.84468 20.305 1.14073 22.9081 1 26.917C1.17677 26.0874 1.40273 25.269 1.67668 24.4663C1.55093 27.1394 1.86229 30.4536 3.55224 34.1928C4.55566 36.3921 6.86546 40.8586 12.5093 44.344L12.5088 44.3443C12.5088 44.3443 14.4288 45.7736 17.7292 46.8447C17.9731 46.9332 18.2201 47.0204 18.4723 47.1049C18.3932 47.0729 18.3166 47.0393 18.2423 47.0048C20.439 47.663 22.7198 47.9982 25.013 47.9999C33.5584 48.0072 36.0787 44.5755 36.0787 44.5755C36.0787 44.5755 36.0698 44.5822 36.0536 44.5939C36.1742 44.4804 36.2904 44.3624 36.4021 44.2399C35.0538 45.5131 31.977 45.5976 30.8265 45.5057C32.7886 44.9295 34.0797 44.442 36.5911 43.4804C36.885 43.3715 37.1855 43.2472 37.4927 43.1077C37.5259 43.0931 37.5594 43.0772 37.5928 43.0621C37.6537 43.0337 37.714 43.0069 37.7756 42.977C38.9992 42.4004 40.1497 41.6801 41.203 40.8313C43.7249 38.8167 44.2736 36.8529 44.5605 35.5581C44.5205 35.6822 44.3958 35.9715 44.3083 36.1589C43.6588 37.5483 42.2185 38.4008 40.6542 39.132C41.3986 38.1553 42.0889 37.1386 42.7219 36.0864C43.2325 35.5799 43.3918 34.7876 43.7731 34.2552Z",
    fill: "url(#paint6_radial)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7039 39.0723C41.7322 37.9386 42.6556 36.6418 43.3551 35.1714C45.1551 31.3869 47.9381 25.0943 45.7462 18.5223C44.0138 13.328 41.6354 10.4878 38.6154 7.71327C33.7108 3.20761 32.341 1.19615 32.341 0C32.341 0 26.6781 6.31263 29.1341 12.8966C31.59 19.4806 36.6199 19.2393 39.9477 26.11C43.8636 34.1951 36.7795 43.018 30.9212 45.4875C31.2799 45.4078 43.9441 42.5419 44.6097 35.2981C44.5946 35.4313 44.3092 37.4348 40.7039 39.0723Z",
    fill: "url(#paint7_radial)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2966 15.5792C24.3158 15.1514 24.0939 14.8641 20.556 14.5322C19.1005 14.3978 18.5431 13.0525 18.3732 12.4863C17.8556 13.831 17.6419 15.2419 17.7568 16.9486C17.8354 18.0667 18.5865 19.2667 18.9456 19.9713C18.9456 19.9713 19.0254 19.8676 19.0622 19.8293C19.7384 19.1253 22.5713 18.0527 22.8374 17.9004C23.1308 17.7151 24.2473 16.8993 24.2966 15.5792Z",
    fill: "url(#paint8_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72267 7.63292C8.67189 7.54423 8.64462 7.81604 8.60559 7.72858C8.31511 7.05477 8.13837 5.96272 8.18023 5.19092C8.18023 5.19092 7.57935 5.46477 7.08203 6.60848C6.98969 6.81409 6.93047 6.9275 6.8713 7.04092C6.84408 7.07399 6.93301 6.66531 6.91881 6.68755C6.83242 6.83389 6.60881 7.03838 6.51169 7.29121C6.43115 7.49799 6.34832 7.60902 6.28666 7.86545C6.26769 7.93516 6.30579 7.55701 6.2892 7.60306C5.13256 9.83843 4.91178 13.2184 5.03369 13.0755C7.49603 10.4462 10.3178 9.82262 10.3178 9.82262C10.0176 9.60145 9.36525 8.96287 8.72272 7.63292H8.72267Z",
    fill: "url(#paint9_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0654 35.1269C14.6642 33.6747 10.7975 31.6266 10.9435 26.9738C11.1422 20.846 16.6578 22.0572 16.6578 22.0572C16.4497 22.1078 15.8932 22.5041 15.696 22.9264C15.4876 23.4546 15.1073 24.6472 16.2595 25.8972C18.0687 27.8578 12.5424 30.5487 21.0723 35.6322C21.2874 35.7492 19.0727 35.5624 18.0655 35.1269H18.0654Z",
    fill: "url(#paint10_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8568 32.0733C19.2686 32.9127 22.0782 32.7654 23.7603 31.8363C24.8864 31.2094 26.331 30.2054 27.2199 30.4532C26.4503 30.149 25.8674 30.0069 25.1662 29.9722C25.0468 29.9722 24.9037 29.9696 24.7737 29.9566C24.5169 29.9557 24.2602 29.9698 24.005 29.9986C23.5709 30.0386 23.0896 30.3125 22.6521 30.2685C22.6284 30.2661 23.0765 30.0844 23.0401 30.0926C22.8083 30.141 22.5564 30.1514 22.2903 30.1844C22.1212 30.2032 21.9757 30.2244 21.8078 30.2314C16.7843 30.6574 12.5387 27.5088 12.5387 27.5088C12.1773 28.7259 14.1566 31.1332 16.8568 32.0733V32.0733Z",
    fill: "url(#paint11_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6945 39.1046C45.7756 34.1158 48.3463 28.0516 47.2596 21.25C47.2596 21.25 47.6937 24.7378 46.0475 28.305C46.8383 24.8224 46.9304 20.4946 44.8292 16.0129C42.0246 10.0309 37.4122 6.88325 35.6513 5.57008C32.9832 3.58038 31.8772 1.55452 31.8573 1.13647C31.0602 2.7695 28.6492 8.36574 31.5982 13.1853C34.3612 17.7006 38.7136 19.0408 41.7606 23.1827C47.374 30.8129 40.6945 39.1046 40.6945 39.1046Z",
    fill: "url(#paint12_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9663 26.1243C38.1906 22.456 35.9743 20.856 33.8778 19.1218C34.1217 19.4633 34.1818 19.5839 34.3168 19.8048C36.162 21.7714 38.883 26.5685 36.9076 32.5905C33.1891 43.9258 18.3152 38.588 16.7559 37.0886C17.3867 43.649 28.3674 46.7884 35.5168 42.534C39.5851 38.6828 42.8762 32.1359 39.9663 26.1243Z",
    fill: "url(#paint13_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.3021 12.0094) rotate(2.55482) scale(16.776 46.1502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.045,
    stopColor: "#FFEA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFDE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#FFBF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429,
    stopColor: "#FF8E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769,
    stopColor: "#FF272D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872,
    stopColor: "#E0255A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953,
    stopColor: "#CC2477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C42482"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.3475 9.42127) scale(47.2807 47.5328)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CCDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0083FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    stopColor: "#007AF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#0060E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#005FE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#2639AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    stopColor: "#401E84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    stopColor: "#4A1475"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 41.7676,
    y1: 30.6154,
    x2: 31.3768,
    y2: 0.42994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000F43",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#001962",
    stopOpacity: 0.173
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002079",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.4245 30.9976) rotate(5.7618) scale(15.9505 14.7532)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#FFEA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#FF272D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C42482"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.5244 15.6355) rotate(5.76177) scale(26.6361 48.8404)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#FFE900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    stopColor: "#FFAF0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#FF7A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#FF4E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    stopColor: "#FF2C2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762,
    stopColor: "#FF1434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.892,
    stopColor: "#FF0538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0039"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.7941 40.58) rotate(5.76175) scale(24.4415 13.3692)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#FF272D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#C42482"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986,
    stopColor: "#620700"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.8873 19.2214) scale(38.1551 39.7668)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#FFEA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#FFDE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#FFBF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541,
    stopColor: "#FF8E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763,
    stopColor: "#FF272D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796,
    stopColor: "#F92433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    stopColor: "#E91C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893,
    stopColor: "#CF0E62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#B5007F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.017 0.0628751) scale(45.0544 113.635)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.279,
    stopColor: "#FFEA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402,
    stopColor: "#FFDD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#FF9100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    stopColor: "#FF6711"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#FF4A1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 10.879,
    y1: 27.1889,
    x2: 28.2911,
    y2: 25.1741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C42482",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#FF272D",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.486,
    stopColor: "#FF2C2C",
    stopOpacity: 0.513
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675,
    stopColor: "#FF7A1A",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#FFB20D",
    stopOpacity: 0.871
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942,
    stopColor: "#FFD605",
    stopOpacity: 0.964
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE302"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 10.3819,
    y1: 11.2172,
    x2: 6.6965,
    y2: 5.21941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#891551",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C42482",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 9.66495,
    y1: 25.6091,
    x2: 14.9427,
    y2: 29.6462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#891551",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#FF272D",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF272D",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 24.7127,
    y1: 32.8267,
    x2: 24.7573,
    y2: 29.1934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C42482"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.083,
    stopColor: "#C42482",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.206,
    stopColor: "#C42482",
    stopOpacity: 0.565
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#C42482",
    stopOpacity: 0.362
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447,
    stopColor: "#C42482",
    stopOpacity: 0.204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#C42482",
    stopOpacity: 0.091
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.673,
    stopColor: "#C42482",
    stopOpacity: 0.023
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#C42482",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 23.6591,
    y1: 18.0915,
    x2: 48.6746,
    y2: 29.7504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF14F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.268,
    stopColor: "#FFEE4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    stopColor: "#FFE643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612,
    stopColor: "#FFD834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757,
    stopColor: "#FFC41E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.892,
    stopColor: "#FFAB02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902,
    stopColor: "#FFA900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949,
    stopColor: "#FFA000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 25.1199,
    y1: 17.2549,
    x2: 17.5283,
    y2: 36.0042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FF8E00",
    stopOpacity: 0.858
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.084,
    stopColor: "#FF8E00",
    stopOpacity: 0.729
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FF8E00",
    stopOpacity: 0.628
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.178,
    stopColor: "#FF8E00",
    stopOpacity: 0.557
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227,
    stopColor: "#FF8E00",
    stopOpacity: 0.514
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.282,
    stopColor: "#FF8E00",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389,
    stopColor: "#FF8E00",
    stopOpacity: 0.478
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524,
    stopColor: "#FF8E00",
    stopOpacity: 0.416
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.676,
    stopColor: "#FF8E00",
    stopOpacity: 0.314
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838,
    stopColor: "#FF8E00",
    stopOpacity: 0.172
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8E00",
    stopOpacity: 0.01
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirefox);
export default __webpack_public_path__ + "static/media/firefox.93c12aff48fa177310b206ef765c0d6a.svg";
export { ForwardRef as ReactComponent };